import { HttpContextToken } from "@angular/common/http";

export const API_IGNORE_ERROR = new HttpContextToken(() => false);
